import React, { useState, useEffect } from "react";
import DocMinter from "../DocMinter.json";

import Loading from "react-loading";

import BarChart from "../Charts/BarChart";

const DataVizualisation = () => {
  const ethers = require("ethers");

  //chart inquiries:
  const [testChart, setTestChart] = useState({
    labels: [2000, 2001, 2002, 2003, 2004],
    datasets: [
      {
        label: "test chart",
        data: [1, 2, 4, 6, 1],
        backgroundColor: ["white", "red", "black", "blue", "green"],
      },
    ],
  });

  const [_data, setData] = useState([]);
  const [dataLoading, setDataLoading] = useState(false);
  const [_maleCounter, setMaleCounter] = useState(0);
  const [_femaleCounter, setFemaleCounter] = useState(0);
  const [finaleResult, setFinaleResult] = useState();

  let _chartData = {
    labels: ["Male", "Female"],
    datasets: [
      {
        label: "Gender dApp users by number",
        data: finaleResult,
        backgroundColor: ["", "#db2d43", "#f7aa00"],
      },
    ],
  };

  async function getDataFromSmartContract() {
    setDataLoading(true);
    const alchemyProvider = new ethers.providers.AlchemyProvider(
      "maticmum",
      "mrvXire3FFkkoWo_HFHsBmRpJDRh1snd"
    );

    const signer = new ethers.Wallet(
      "794544ea59d049cc26fd0607233516895afec782c05f13cf30c9c025b7f8591e",
      alchemyProvider
    );

    let contract = new ethers.Contract(
      DocMinter.address,
      DocMinter.abi,
      signer
    );

    let calling = await contract.getData();
    setData(calling);
    console.log(calling);
    console.log(
      calling.map((value) => {
        return value._gender;
      })
    );
    getGenderRepetition(calling);
    setDataLoading(false);
  }

  function getGenderRepetition(list) {
    let result = list.map((val) => val._gender);

    let maleCounter = 0;
    let femalecounter = 0;
    for (let i = 0; i < result.length; i++) {
      if (result[i] === "Male") {
        maleCounter++;
      } else if (result[i] === "Female") {
        femalecounter++;
      }
    }

    setMaleCounter(maleCounter);
    setFemaleCounter(femalecounter);
    setFinaleResult([maleCounter, femalecounter]);
    console.log([maleCounter, femalecounter]);
    console.log("success", finaleResult);
  }

  useEffect(() => {
    getDataFromSmartContract();
  }, []);

  return (
    <div className="viewer">
      DataVizualisation <br />
      <button className="dataViewer" onClick={getDataFromSmartContract}>
        click here
      </button>
      {dataLoading && (
        <div className="loading-modal">
          <Loading type="spin" color="black" height={50} width={50} />
        </div>
      )}
      <BarChart ChartData={_chartData} />
    </div>
  );
};

export default DataVizualisation;
